import React, { useState } from "react";
import { galleryData } from "../Data";

export const Gallery = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openModal = (index) => {
    setCurrentIndex(index);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const showPrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + galleryData.length) % galleryData.length
    );
  };

  const showNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % galleryData.length);
  };

  return (
    <>
      <div
        className="h-[16rem] md:h-[20rem] bg-cover relative bg-center flex items-center justify-center text-white"
        style={{
          backgroundImage: 'url("./img/gallery.png")',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-slate-800/70 to-slate-900/90"></div>
        <div className="relative z-10 text-center px-6">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold mb-4 tracking-wide">
            Our Gallery
          </h1>
          <p className="text-lg md:text-xl text-slate-100 max-w-3xl mx-auto">
            A glimpse into our work and laboratory
          </p>
        </div>
      </div>
      <div className="max-w-screen-xl mx-auto px-4 py-12 bg-gray-50">
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 gap-8 justify-center items-center">
          {galleryData.map((client, index) => (
            <div key={client.id} className="cursor-pointer">
              <img
                src={client.imageSrc}
                alt={client.name}
                onClick={() => openModal(index)}
                className="object-cover w-full max-w-[500px] h-[300px] border-2 border-blue-200 rounded-xl shadow-md hover:scale-105 hover:shadow-xl transition-all mx-auto"
              />
            </div>
          ))}
        </div>


        {isOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
            <div className="relative bg-gray-100 p-6 rounded-lg shadow-2xl max-w-3xl w-full mx-4">
              <button
                onClick={closeModal}
                className="absolute top-2 right-3 text-gray-700 hover:text-red-500 text-2xl font-bold"
              >
                &times;
              </button>

              <img
                src={galleryData[currentIndex].imageSrc}
                alt={galleryData[currentIndex].name}
                className="mx-auto object-contain w-[90vw] max-w-[600px] h-[400px]"
              />

              <button
                onClick={showPrev}
                className="absolute left-2 top-1/2 transform -translate-y-1/2 text-3xl text-gray-600 hover:text-black"
              >
                &#10094;
              </button>
              <button
                onClick={showNext}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 text-3xl text-gray-600 hover:text-black"
              >
                &#10095;
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
